import React, { memo } from 'react'
import { Box } from '@mui/material'

import SignupInputContent from './SignupInputContent'
import AcceptTerms from './AcceptTerms'
import { LOG_IN_URL } from '../../constants/navigation'
import { SIGN_UP_FORM_STATE } from '../../constants/containerStates'
import PageContainer from '../shared/PageContainer/PageContainer'
import Link from '../shared/link/Link'
import Text from '../shared/text/Text'
import CustomForm from '../shared/forms/customForm/CustomForm'
import CustomButton from '../shared/buttons/CustomButton'
import UnauthorizedLayoutContainer from '../../containers/UnauthorizedLayoutContainer'
import { QB_ACTION_SUBMIT } from '../../constants/input'

const Signup = ({
  signupProfile,
  dispatchAction,
  onSignupSubmit,
  onBackAction,
  t
}) => {
  const signupFormState = signupProfile.signupFormState
  const renderFields = () => {
    switch (signupFormState) {
      case SIGN_UP_FORM_STATE.PROFILE:
        return (
          <SignupInputContent
            signupProfile={signupProfile}
            dispatchAction={dispatchAction}
            t={t}
          />
        )
      case SIGN_UP_FORM_STATE.ACCEPT_TERMS:
        return (
          <AcceptTerms
            signupProfile={signupProfile}
            dispatchAction={dispatchAction}
            t={t}
          />
        )
      default:
        return
    }
  }

  const isProfileSelected = signupFormState === SIGN_UP_FORM_STATE.PROFILE
  const title = t('sign-up.create-your-account')
  return (
    <PageContainer title={title}>
      <UnauthorizedLayoutContainer title={title}>
        <Box display='flex' alignItems='center'>
          <Text
            variant='h6'
            label={t('sign-up.already-have-an-account')}
            color='textSecondary'
            sx={{ mr: 1 }}
          />
          <Link to={LOG_IN_URL} label={t('log-in.log-in')} fontWeight={500} />
        </Box>
        <Box
          sx={{
            mt: 4
          }}
        >
          <CustomForm onFormSubmit={onSignupSubmit}>
            {renderFields()}
            <CustomButton
              sx={{ mt: 4 }}
              type={QB_ACTION_SUBMIT}
              label={t('sign-up.sign-up')}
              size='large'
              disabled={signupProfile.isProcessing}
            />
            {!isProfileSelected && (
              <CustomButton
                sx={{ mt: 2 }}
                label={t('common.back')}
                onClick={onBackAction}
                variant=''
                size='large'
              />
            )}
          </CustomForm>
        </Box>
      </UnauthorizedLayoutContainer>
    </PageContainer>
  )
}

export default memo(Signup)
